import { Container, Row, Col } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { Title, Body, SocialShareDropdown, SidebarNavigation } from "@/ui";
import { Buttons } from "@/ui/Buttons";
import { getRoute } from "@/getters/getRoute";
import { useRouter } from "next/router";
import useDynamicPages from "@/hooks/useDynamicPages";
import useDynamicPage from "@/hooks/useDynamicPage";

export default function RichText({ className, bgColor, title, titleColor, body, share = false, sidebar = false, buttons }) {
  const url_slug = useRouter().asPath.slice(1, -1);
  const path = url_slug.split("/").slice(0, -1).join("/");
  const siblings = useDynamicPages().filter((i) => i.url_slug.startsWith(path.concat("/")));
  const parent = useDynamicPage(path);
  
  if (!body && !title && !buttons) return null;
  
  if (sidebar) {
    var sidebarNavigation = [
      {
        label: parent?.title,
        href: getRoute("simplePage", { url_slug: parent?.url_slug }),
        children: siblings
          .sort((a, b) => {
            if (a.name > b.name) return 1;
            if (a.name < b.name) return -1;
            return 0;
          })
          .map((i) => {
            return {
              label: i.title,
              href: getRoute("simplePage", { url_slug: i?.url_slug }),
              active: i.url_slug === url_slug,
            };
          }),
      },
    ]
  }

  return (
    <div className={clsx(className, bgColor, classes.text)}>
      <Container>
        <Row>
          <Col xs={12} md={share || sidebar ? 8 : 12}>
            <Title className={titleColor} title={title} />
            <Body body={body} />
            <Buttons buttons={buttons} className="mt-4" />
          </Col>
          {(share || sidebar) && (
            <Col xs={12} md={4}>
              {share &&
                <SocialShareDropdown />
              }
              {sidebar &&
                <>
                <SidebarNavigation title="In this section" items={sidebarNavigation} />
                </>
              }
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
